import { useEffect, useState } from "react";

import "./FiltroCategorie.css"

/**
 *  Componente per il filtraggio di categorie di una data sezione
 * @param {Array} categories   
 * @param {String} filteredCategory
 * @returns Component
 */
const FiltroCategorie = ({ categories, filteredCategory, customCss }) => {
    // Variabile contenente la categoria selezionata
    const [selectedCategory, setSelectedCategory] = useState(categories[0]);

    /**
     * Manda la categoria selezione ad ogni selezione
     */
    useEffect(() => {
        if (filteredCategory ? filteredCategory(selectedCategory) : null) {
            filteredCategory(selectedCategory)
        }
    }, [selectedCategory]);

    return <div className={`container_filtro_categoria ${customCss}`} >
        {categories.map((category, index) => (
            <div key={index} className={`tab ${selectedCategory === category ? "active-tab" : ""}`} onClick={() => setSelectedCategory(category)}>
                <p>{category}</p>
            </div>
        ))}
    </div>
}

export default FiltroCategorie;